import { FETCH_CATTLEDETAIL_FAILURE, FETCH_CATTLEDETAIL_REQUEST, FETCH_CATTLEDETAIL_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const posCattleDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CATTLEDETAIL_REQUEST:
            return {
                ...state,
            }
        case FETCH_CATTLEDETAIL_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_CATTLEDETAIL_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}